import { Backdrop } from '@mui/material';
import { Loading } from '@/components/Loading/Loading';

export const LoadingScreen = () => (
    <Backdrop open>
        <Loading />
    </Backdrop>
);
